import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const Lanterns = () => {
  const lanternsRef = useRef([]);
  
  // 重置燈籠參考陣列
  lanternsRef.current = [];
  
  useEffect(() => {
    // 判斷是否為行動裝置
    const isMobile = window.innerWidth <= 768;
    const scaleFactor = isMobile ? 1.2 : 1.4;  // 整體放大燈籠尺寸
    
    // 為每個燈籠設置不同的浮動動畫
    lanternsRef.current.forEach((lantern, index) => {
      // 根據裝置調整燈籠的大小和位置
      const lanternScale = (0.8 + (index % 3) * 0.2) * scaleFactor;
      
      // 設置不同的初始位置和大小
      gsap.set(lantern, {
        x: `${-20 + (index * 25)}%`,
        y: -40 - (index % 2) * 40,
        scale: lanternScale,
        opacity: 0
      });
      
      // 淡入動畫
      gsap.to(lantern, {
        opacity: 1,
        duration: 1,
        delay: 0.2 + index * 0.3,
        ease: "power1.out"
      });
      
      // 浮動動畫 - 使用隨機數值讓每個燈籠有不同的浮動節奏
      gsap.to(lantern, {
        y: `-=${10 + index * 5}`,
        duration: 3 + index * 0.5,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: index * 0.4
      });
      
      // 輕微旋轉
      gsap.to(lantern, {
        rotation: index % 2 === 0 ? 3 : -3,
        duration: 4 + index * 0.7,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: index * 0.2
      });
    });
  }, []);
  
  return (
    <div className="lanterns-container">
      {/* 創建5個燈籠 */}
      {[...Array(5)].map((_, index) => (
        <div 
          key={index} 
          className="lantern"
          ref={el => lanternsRef.current[index] = el}
        />
      ))}
    </div>
  );
};

export default Lanterns;